import TintucPageApi from "./TintucPageApi";
import MenuApi from './MenuApi';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function Header() {
  const [data, setData] = useState([]);
  const [menuItems, setMenuItems] = useState(null); // null => dùng menu mặc định (hardcoded)
  const [isOpen, setIsOpen] = useState(false);
  const [openSubmenuId, setOpenSubmenuId] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    TintucPageApi.getAllType(16).then((data) => {
      setData(data); // Update state with the resolved data
    }).catch((error) => {
      console.error("Failed to fetch data:", error); // Handle errors
    });

    MenuApi.getMenuForCode('header').then((items) => {
      if (items && items.length > 0) {
        setMenuItems(items);
      }
    });
  }, []);

  const toggleSubmenu = (id) => {
    setOpenSubmenuId(openSubmenuId === id ? null : id);
  };

  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
    if (isOpen) setIsOpen(false); // Close menu if search is opened
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (searchOpen) setSearchOpen(false); // Close search if menu is opened
  };

  return (
    <nav className="navbar navbar-default navbar-fixed-top">
      {/* Mobile Search Bar Slide Down */}
      <div className={`search-mobile-bar ${searchOpen ? 'active' : ''}`}>
        <form action="/Search" method="get" role="search" className="search-mobile-form">
          <input 
            className="search-mobile-input" 
            placeholder="Tìm kiếm..." 
            name="keywords" 
            id="keywords-mobile" 
            type="text" 
            autoFocus={searchOpen}
          />
          <button className="search-mobile-submit" type="submit">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </form>
      </div>

      <div className="container">
        {/* Brand and toggle get grouped for better mobile display */}
        <div className="navbar-header">
          <div className="navbar-mobile-right">
            <button 
              type="button" 
              className="search-toggle-mobile-btn" 
              onClick={toggleSearch}
              aria-label="Toggle search"
            >
              {searchOpen ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              )}
            </button>
            <button 
              type="button" 
              className={`navbar-toggle ${isOpen ? '' : 'collapsed'}`} 
              onClick={toggleMenu}
              aria-expanded={isOpen}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
          <a className="navbar-brand" href="/"> 
            <img className="logoAnimation" src={require("./Upload/images/tab/tab1.png")} alt="Logo" /> 
            <span>LINH QUY PHÁP ẤN</span> 
          </a>
        </div>

        {/* Collect the nav links, forms, and other content for toggling */}
        <div className={`collapse navbar-collapse menuHeader ${isOpen ? 'in' : ''}`} id="bs-example-navbar-collapse-1">
          {/* Desktop Search */}
          <div className="search-desktop-container">
            <form action="/Search" method="get" role="search" className={`search-desktop-form ${searchOpen ? 'active' : ''}`}>
              <input 
                className="search-desktop-input" 
                placeholder="Tìm kiếm..." 
                name="keywords" 
                id="keywords-desktop" 
                type="text" 
              />
              <button className="search-desktop-submit" type="submit">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </form>
            <button 
              type="button" 
              className="search-toggle-desktop-btn" 
              onClick={() => setSearchOpen(!searchOpen)}
              aria-label="Toggle search"
            >
              {searchOpen ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              )}
            </button>
          </div>

          <ul className="nav navbar-nav navbar-right">
            {menuItems && menuItems.length > 0 ? (
              menuItems.map((item) => (
                item.url === '/tin-tuc' ? (
                  <li key={item.id} className={`dropdown ${openSubmenuId === item.id ? 'open' : ''}`}>
                    <div className="menu-item-row">
                      <a href={item.url}> {item.name}</a>
                      <button 
                        className="submenu-toggle-btn" 
                        onClick={(e) => { e.preventDefault(); toggleSubmenu(item.id); }}
                        aria-expanded={openSubmenuId === item.id}
                      >
                        <svg className={`chevron-icon ${openSubmenuId === item.id ? 'rotated' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>
                    </div>
                    <ul className="dropdown-menu">
                      {data?.map((sub) => (
                        <li key={sub.Id}>
                          <a href={`/tin-tuc?title=${sub.Name}&catId=${sub.Id}`}>{sub.Name}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li key={item.id}>
                    <a href={item.url}> {item.name}</a>
                  </li>
                )
              ))
            ) : (
              <>
                <li>
                  <a href="/"> TRANG CHỦ</a>
                </li>
                <li>
                  <a href="/video"> VIDEO</a>
                </li>
                <li>
                  <a href="/audio"> AUDIO</a>
                </li>
                <li className={`dropdown ${openSubmenuId === 'tin-tuc' ? 'open' : ''}`}>
                  <div className="menu-item-row">
                    <a href="/tin-tuc"> TIN TỨC</a>
                    <button 
                      className="submenu-toggle-btn" 
                      onClick={(e) => { e.preventDefault(); toggleSubmenu('tin-tuc'); }}
                      aria-expanded={openSubmenuId === 'tin-tuc'}
                    >
                      <svg className={`chevron-icon ${openSubmenuId === 'tin-tuc' ? 'rotated' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </button>
                  </div>
                  <ul className="dropdown-menu">
                    {data?.map((item) => (
                      <li key={item.Id}>
                        <a href={`/tin-tuc?title=${item.Name}&catId=${item.Id}`}>{item.Name}</a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <a href="/hinh-anh"> HÌNH ẢNH</a>
                </li>
                <li>
                  <a href="/bai-giang-pho-thong"> Bài Giảng Phổ Thông</a>
                </li>
                <li>
                  <a href="/kinh-sach"> KINH SÁCH</a>
                </li>
                <li>
                  <a href="/contact"> Liên hệ</a>
                </li>
              </>
            )}
          </ul>
        </div>{/* /.navbar-collapse */}
      </div>{/* /.container-fluid */}
    </nav>
  );
}

export default Header;
